// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__xEgEn","button":"footer_button__S6ZWI"};